import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
    production: true,
    apiUrl: 'https://api.petszel.com/',
    dashboardUrl: 'https://shelter.petszel.com',
    petParentAppUrl: 'https://app.petszel.com/',
    logger: {
      level: NgxLoggerLevel.ERROR,
      serverLogLevel: NgxLoggerLevel.ERROR,
      disableConsoleLogging: true,
    }
  };
